import React, {Component} from 'react';
import {Form, Field} from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import {FieldArray} from 'react-final-form-arrays'
import PropTypes from 'prop-types';

function formatMoney(money) {
  // TODO: Implement me
  return money;
}

export default class TopTwentyView extends Component {
  static propTypes = {
    top_twenty: PropTypes.object,
  };

  creditor_item = (creditor, index) => (
    <tr>
      <td>
        <span id="address">{index+1}</span>
      </td>
      <td>
        <span id="address">{creditor.name_addr}</span>
      </td>
      <td>
        <span id="contact">{creditor.contact_addr}</span>
      </td>
      <td>
        <span id="claim-type">{creditor.claim_type}</span>
      </td>
      <td>
        <span id="claim-status">{creditor.claim_status}</span>
      </td>
      <td class="money">
        <span id="total">$ {formatMoney(creditor.total)}</span>
      </td>
      <td class="money">
        <span id="deduction">$ {formatMoney(creditor.deduction)}</span>
      </td>
      <td class="money">
        <span id="deduction">$ {formatMoney(creditor.unsecured)}</span>
      </td>
    </tr>
  );

  render() {
    if (this.props.top_twenty.empty)
      return <div>{this.props.top_twenty.empty}</div>


    const { creditors } = this.props.top_twenty.data;


    return (
      <div id="top-twenty">
        <div id="top-twenty-filters">
          <form id="parser-top-twenty-form">
            <input
              type="text" name="keyword" id="alfresco-keyword"
              class="form-text"
              size="30"
              placeholder="Enter Keywords"
            />

            $<input
            type="text" name="value_from" id="value-from" placeholder="value"
            class="form-text"
          /> to
            $<input
            type="text" name="value_to" id="value-to" placeholder="value"
            class="form-text"
          />

            <button type="submit" className="form-submit">
              <span className="magnifier icon"></span>
            </button>
            <a href="#" id="alfresco-clear">clear</a>
          </form>
        </div>

        <div id="ir-search-top-twenty-results">
          <table id="creditors">
            <thead>
              <tr>
                <th rowSpan="2" colSpan="2">
                  <span className="label">Name of creditor and complete mailing address, including zip code</span>
                </th>
                <th rowSpan="2">
                  <span className="label">Name, telephone number, and email address of creditor contact</span>
                </th>
                <th rowSpan="2">
                  <span className="label">Nature of the claim</span>
                  <span className="schedule-tips">(for example, trade debts, bank loans, professional services, and government contracts)</span>
                </th>
                <th rowSpan="2">
                  <span className="label">Indicate if claim is contingent, unliquidated, or disputed</span>
                </th>
                <th colSpan="3">
                  <span className="label">Amount of unsecured claim</span>
                  <span className="schedule-tips">If the claim is fully unsecured, fill in only unsecured claim amount.
                  If amount is partially secured, fill in total claim amount and deduction for value of collateral or setoff to calculate unsecured claim.</span>
                </th>
              </tr>
              <tr>
                <th>Total claim, if partially secured</th>
                <th>Deduction for value of collateral or setoff</th>
                <th>Unsecured claim</th>
              </tr>
            </thead>
            <tbody>
            {creditors && creditors.map(this.creditor_item)}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

}


/** WEBPACK FOOTER **
 ** ./src/scheduleform/TopTwentyView.jsx
 **/